import { render, staticRenderFns } from "./RosterIndex.vue?vue&type=template&id=25c0a75b&scoped=true&"
import script from "./RosterIndex.vue?vue&type=script&lang=js&"
export * from "./RosterIndex.vue?vue&type=script&lang=js&"
import style0 from "./RosterIndex.vue?vue&type=style&index=0&id=25c0a75b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c0a75b",
  null
  
)

export default component.exports